<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('categories')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="25"
      resource_url="/helpdesk/category/datatables"
    ></generic-table>
  </div>

  <category-modal ref="category_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
} from "@/utils";
import CategoryModal from "./category_modal/Index.vue";

export default {
  name: "CategoriesDatatable",
  components: { GenericTable, CategoryModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("add_category"),
          icon: "fa fa-plus",
          class: "is-primary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            const colorStyle = row.color
              ? `background-color: ${row.color}; color: white;`
              : "";
            return `<div class="media">
              <div class="media-left">
                <span class="tag" style="${colorStyle}">
                  <i class="fa fa-folder"></i>
                </span>
              </div>
              <div class="media-content">
                <div class="content">
                  <p class="title is-6 mb-1">${row.name || ""}</p>
                  <p class="subtitle is-7 has-text-grey">${
                    row.description || ""
                  }</p>
                </div>
              </div>
            </div>`;
          },
        },
        {
          title: v.$t("sla_hours"),
          searchable: false,
          data: (row) => {
            if (row.sla_hours) {
              return `<span class="tag is-info">${row.sla_hours}h</span>`;
            }
            return "";
          },
        },
        {
          title: v.$t("requires_approval"),
          searchable: false,
          data: (row) => {
            const statusClass = row.requires_approval
              ? "is-warning"
              : "is-success";
            const statusText = row.requires_approval ? v.$t("yes") : v.$t("no");
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: v.$t("auto_assignment"),
          searchable: false,
          data: (row) => {
            const statusClass = row.auto_assignment_enabled
              ? "is-success"
              : "is-dark";
            const statusText = row.auto_assignment_enabled
              ? v.$t("enabled")
              : v.$t("disabled");
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            const statusClass = row.is_active ? "is-success" : "is-danger";
            const statusText = row.is_active
              ? v.$t("active")
              : v.$t("inactive");
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.category_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are_you_sure_delete"),
                    v,
                    () => {
                      del("/helpdesk/category", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.category_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
